let globalCompare
function vueGlobalCompare() {
    globalCompare = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const store = window.compareStore();
            store?.loadFromStorage?.();

            const defaultImage = window.defaultTyreImage || '';
            const promoStore = window.promo ? window.promo() : null;
            const priceFormat = promoStore?.priceFormat || ((value) => value);
            const canCompare = Vue.computed(() => (store.selectedProducts || []).length >= 2);
            const compareDetails = Vue.reactive({});
            const loadingDetails = Vue.ref(false);

            const totalCompare = () => (store.selectedProducts || []).length;
            const closeDrawer = () => store.setDrawerOpen ? store.setDrawerOpen(false) : (store.isDrawerOpen = false);
            const clearAll = () => store.clearAll ? store.clearAll() : (store.selectedProducts = []);
            const removeFromCompare = (id) => store.removeById ? store.removeById(id) : null;

            const normalizeProductId = (id) => {
                if (!id) return '';
                const text = String(id);
                return text.includes('gid://shopify/Product/') ? text.replace('gid://shopify/Product/', '') : text;
            };

            const toProductGid = (id) => {
                const normalized = normalizeProductId(id);
                return normalized ? `gid://shopify/Product/${normalized}` : '';
            };

            const toInches = (value) => {
                const text = String(value || '').trim();
                if (!text) return '';
                const rMatch = text.match(/r\s*(\d{2})\b/i);
                if (rMatch?.[1]) return `${Number(rMatch[1])} inches`;
                const inchMatch = text.match(/(\d{2})(?:\.\d+)?\s*(?:inch|inches)\b/i);
                if (inchMatch?.[1]) return `${Number(inchMatch[1])} inches`;
                return text;
            };

            const normalizeSingleMetafieldValue = (value) => {
                if (Array.isArray(value)) {
                    const first = value[0];
                    return first == null ? '' : String(first).trim();
                }
                const text = String(value || '').trim();
                if (!text) return '';
                if (text.startsWith('[') && text.endsWith(']')) {
                    try {
                        const parsed = JSON.parse(text);
                        if (Array.isArray(parsed)) {
                            const first = parsed[0];
                            return first == null ? '' : String(first).trim();
                        }
                    } catch (e) {}
                }
                return text;
            };

            const fetchCompareDetails = async () => {
                if (!shopifyConfig?.storeURL || !shopifyConfig?.apiVersion || !shopifyConfig?.PLP) return;
                const products = store.selectedProducts || [];
                const missing = products
                    .map((p) => normalizeProductId(p?.id || p?.node?.id))
                    .filter((id) => id && !compareDetails[id]);
                if (!missing.length) return;

                const gids = missing.map((id) => toProductGid(id)).filter(Boolean);
                if (!gids.length) return;
                loadingDetails.value = true;
                try {
                    const idList = gids.map((gid) => `"${gid}"`).join(',');
                    const query = `{
                        nodes(ids:[${idList}]) {
                            ... on Product {
                                id
                                title
                                availableForSale
                                category { name }
                                collections(first:50) {
                                    edges {
                                        node {
                                            promoType: metafield(namespace:"promotion",key:"type") { value }
                                            promoValue: metafield(namespace:"promotion",key:"value") { value }
                                            promoTitle: metafield(namespace:"promotion",key:"title") { value }
                                            promoColour: metafield(namespace:"promotion",key:"colour") { value }
                                        }
                                    }
                                }
                                selectedOrFirstAvailableVariant {
                                    title
                                    loadIndex: metafield(namespace:"tyre_spec",key:"load_index") { value }
                                    speedRating: metafield(namespace:"tyre_spec",key:"speed_rating") { value }
                                    aspectRatio: metafield(namespace:"tyre_spec",key:"aspect_ratio") { value }
                                    rimDiameter: metafield(namespace:"wheel_tyre_spec",key:"rim_diameter") { value }
                                    width: metafield(namespace:"wheel_tyre_spec",key:"width") { value }
                                }
                                bolt: metafield(namespace:"wheel_spec",key:"bolt") { value }
                                pcd: metafield(namespace:"wheel_spec",key:"pcd") { value }
                                offset: metafield(namespace:"wheel_spec",key:"offset") { value }
                                centreBore: metafield(namespace:"wheel_spec",key:"centre_bore") { value }
                                loadRating: metafield(namespace:"wheel_spec",key:"load_rating_kg") { value }
                            }
                        }
                    }`;
                    const res = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                        },
                        body: JSON.stringify({ query })
                    });
                    const json = await res.json();
                    const nodes = Array.isArray(json?.data?.nodes) ? json.data.nodes : [];
                    nodes.forEach((node) => {
                        if (!node?.id) return;
                        const id = normalizeProductId(node.id);
                        const categoryName = String(node?.category?.name || '').toLowerCase();
                        const titleText = String(node?.title || '').toLowerCase();
                        const variant = node?.selectedOrFirstAvailableVariant || {};
                        const isWheel = categoryName.includes('wheel')
                            || titleText.includes('wheel')
                            || Boolean(node?.bolt?.value || node?.pcd?.value || node?.offset?.value || node?.centreBore?.value);
                        const promoEdge = (node?.collections?.edges || []).find((edge) => edge?.node?.promoType?.value);
                        const promoType = promoEdge?.node?.promoType?.value || '';
                        const promoValue = Number(promoEdge?.node?.promoValue?.value || 0);
                        const promoTitle = promoEdge?.node?.promoTitle?.value || '';
                        const promoColour = promoEdge?.node?.promoColour?.value || '';
                        compareDetails[id] = {
                            isWheel,
                            variantTitle: variant?.title || '',
                            productTitle: node?.title || '',
                            loadIndex: variant?.loadIndex?.value || '',
                            speedRating: variant?.speedRating?.value || '',
                            rimDiameter: toInches(variant?.rimDiameter?.value || ''),
                            width: variant?.width?.value || '',
                            aspectRatio: variant?.aspectRatio?.value || '', 
                            rimDiameterRaw: variant?.rimDiameter?.value || '',
                            bolt: node?.bolt?.value || '',
                            pcd: normalizeSingleMetafieldValue(node?.pcd?.value),
                            offset: node?.offset?.value || '',
                            centreBore: node?.centreBore?.value || '',
                            loadRating: node?.loadRating?.value || '',
                            available: typeof node?.availableForSale === 'boolean' ? node.availableForSale : null,
                            promoType,
                            promoValue,
                            promoTitle,
                            promoColour
                        };
                    });
                } catch (e) {
                    console.error('Compare details fetch failed', e);
                } finally {
                    loadingDetails.value = false;
                }
            };

            const getProductDetails = (p) => compareDetails[normalizeProductId(p?.id || p?.node?.id)] || null;

            const isWheelProduct = (p) => {
                const details = getProductDetails(p);
                if (details?.isWheel === true) return true;
                const title = String(p?.title || p?.node?.title || '').toLowerCase();
                return title.includes('wheel');
            };

            const compareMode = Vue.computed(() => {
                const products = store.selectedProducts || [];
                if (!products.length) return 'tyres';
                const wheelCount = products.filter((p) => isWheelProduct(p)).length;
                return wheelCount > 0 && wheelCount === products.length ? 'wheels' : 'tyres';
            });

            const compareTitle = Vue.computed(() => compareMode.value === 'wheels' ? 'Compare Wheels' : 'Compare Tyres');
            const compareUnitLabel = Vue.computed(() => compareMode.value === 'wheels' ? 'wheel' : 'tyre');

            const featureRows = Vue.computed(() => {
                if (compareMode.value === 'wheels') {
                    return [
                        { key: 'priceEach', label: 'Price per wheel' },
                        { key: 'priceSet4', label: 'Price for set of 4' },
                        { key: 'set4Offer', label: 'Set of 4 discount' },
                        { key: 'wheelSize', label: 'Wheel size' },
                        { key: 'fitsVehicle', label: 'Fits your vehicle' },
                        { key: 'stockStatus', label: 'Stock status' },
                        { key: 'bolt', label: 'Bolt pattern' },
                        { key: 'pcd', label: 'PCD' },
                        { key: 'offset', label: 'Offset' },
                        { key: 'centreBore', label: 'Centre bore' },
                        { key: 'loadRating', label: 'Load rating (kg)' }
                    ];
                }
                return [
                    { key: 'priceEach', label: 'Price per tyre' },
                    { key: 'priceSet4', label: 'Price for set of 4' },
                    { key: 'set4Offer', label: 'Set of 4 discount' },
                    { key: 'tyreSize', label: 'Tyre size' },
                    { key: 'fitsVehicle', label: 'Fits your vehicle' },
                    { key: 'stockStatus', label: 'Stock status' },
                    { key: 'loadIndex', label: 'Load index' },
                    { key: 'speedRating', label: 'Speed rating' }
                ];
            });

            const getSetOf4Pricing = (unitPrice, details) => {
                const base = Number(unitPrice || 0) * 4;
                const type = String(details?.promoType || '').trim();
                const value = Number(details?.promoValue || 0);
                if (!type || !base) return { total: base, saving: 0, hasDiscount: false, type: '' };

                if (type === 'Cash Back' && value > 0) {
                    return { total: Math.max(0, base - value), saving: value, hasDiscount: true, type };
                }
                if (type === 'Percentage' && value > 0) {
                    const saving = base * (value / 100);
                    return { total: Math.max(0, base - saving), saving, hasDiscount: true, type };
                }
                if (type === 'Buy 3 Get 4') {
                    const saving = Math.max(0, Number(unitPrice || 0) - 25);
                    return { total: Math.max(0, base - saving), saving, hasDiscount: true, type };
                }
                return { total: base, saving: 0, hasDiscount: false, type: '' };
            };

            const getPromoInfo = (p) => {
                const details = getProductDetails(p) || {};
                const unitPrice = Number(p?.price || 0);
                const set4 = getSetOf4Pricing(unitPrice, details);
                return {
                    hasPromo: set4.hasDiscount,
                    title: details.promoTitle || details.promoType || '',
                    colour: details.promoColour || '',
                    unitPrice: set4.hasDiscount ? (set4.total / 4) : unitPrice,
                    set4
                };
            };

            const promoBadgeStyle = (p) => {
                const info = getPromoInfo(p);
                if (!info.hasPromo || !info.colour) return {};
                return { backgroundColor: info.colour };
            };

            const getCompareValue = (p, key) => {
                const details = getProductDetails(p) || {};
                const unitPrice = Number(p?.price || 0);
                const set4 = getSetOf4Pricing(unitPrice, details);
                const promoInfo = getPromoInfo(p);
                switch (key) {
                    case 'priceEach':
                        if (promoInfo.hasPromo) {
                            return `${priceFormat(promoInfo.unitPrice)} (promo)`;
                        }
                        return priceFormat(unitPrice);
                    case 'priceSet4':
                        if (set4.hasDiscount) {
                            return `${priceFormat(set4.total)} (was ${priceFormat(unitPrice * 4)})`;
                        }
                        return priceFormat(unitPrice * 4);
                    case 'set4Offer':
                        if (!set4.hasDiscount || set4.saving <= 0) return '—';
                        return `Save ${priceFormat(set4.saving)}`;
                    case 'tyreSize': {
                        const w = details.width;
                        const a = details.aspectRatio;
                        const r = details.rimDiameterRaw ? String(Number(details.rimDiameterRaw)) : '';
                        if (w && a && r) return `${w}/${a}R${r}`;
                        const raw = details.variantTitle?.toLowerCase() !== 'default title'
                            ? details.variantTitle
                            : (details.productTitle || '');
                        const title = String(raw || '');
                        const sizeMatch = title.match(/(\d{3})\s*\/\s*(\d{2})\s*([A-Z]{1,3})?\s*R\s*(\d{2}(?:\.\d+)?)/i);
                        if (sizeMatch) {
                            const [, width, aspect, ratingPrefix, rim] = sizeMatch;
                            return `${width}/${aspect}${(ratingPrefix || '').toUpperCase()}R${rim}`;
                        }
                        return '—';
                    }

                    case 'wheelSize': {
                        const r = details.rimDiameterRaw ? String(Number(details.rimDiameterRaw)) : '';
                        if (r) return `${r} inches`;
                        const raw = details.variantTitle?.toLowerCase() !== 'default title'
                            ? details.variantTitle
                            : (details.productTitle || '');
                        const title = String(raw || '');
                        const sizeToken = title.split(/[\s|]+/).find(p => /^\d{2}(\.\d+)?[xX]/i.test(p));
                        return sizeToken ? `${Number(sizeToken.split(/[xX]/)[0])} inches` : '—';
                    }
                    case 'fitsVehicle':
                        return p?.fits_vehicle === true ? 'Yes' : (p?.fits_vehicle === false ? 'No' : '—');
                    case 'stockStatus': {
                        const available = typeof details.available === 'boolean' ? details.available : p?.available;
                        return available ? 'In stock' : 'Out of stock';
                    }
                    case 'loadIndex':
                        return details.loadIndex || '—';
                    case 'speedRating':
                        return details.speedRating || '—';
                    case 'bolt':
                        return details.bolt || '—';
                    case 'pcd':
                        return details.pcd || '—';
                    case 'offset':
                        return details.offset || '—';
                    case 'centreBore':
                        return details.centreBore || '—';
                    case 'loadRating':
                        return details.loadRating || '—';
                    default:
                        return '—';
                }
            };

            const isPromoPriceRow = (p, key) => {
                const promo = getPromoInfo(p);
                if (!promo?.hasPromo) return false;
                return key === 'priceEach' || key === 'priceSet4' || key === 'set4Offer';
            };

            const openCompareModal = () => {
                if (!canCompare.value) return;
                store.isCompareModalOpen = true;
                store.persist?.();
                fetchCompareDetails();
            };

            const closeCompareModal = () => {
                store.isCompareModalOpen = false;
                store.persist?.();
            };

            const closeCompareLimitDialog = () => {
                store.closeCompareLimitDialog?.();
            };

            Vue.watch(
                () => (store.selectedProducts || []).map((p) => normalizeProductId(p?.id || p?.node?.id)).join(','),
                () => {
                    fetchCompareDetails();
                },
                { immediate: true }
            );

            return {
                store,
                defaultImage,
                priceFormat,
                canCompare,
                totalCompare,
                closeDrawer,
                clearAll,
                removeFromCompare,
                openCompareModal,
                closeCompareModal,
                closeCompareLimitDialog,
                compareTitle,
                compareUnitLabel,
                featureRows,
                getCompareValue,
                getPromoInfo,
                promoBadgeStyle,
                isPromoPriceRow
            };
        }
    });
    globalCompare.use(window.VueAppGlobals.pinia);
    globalCompare.mount('#globalCompare');
}

if (window.Vue && window.Pinia) {
    vueGlobalCompare();
} else {
    window.addEventListener('vue-ready', function () {
        vueGlobalCompare();
    });
}
